'use client';

import { HeaderStore } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { useStoreInfoDrawer } from './store-info-drawer/store-info-drawer-context';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import { useState, useLayoutEffect } from 'react';
import { returnFocusToNavItem } from '../../utils/common-utils';
import { useStoreLocatorTooltip } from '../../hooks/use-store-locator-tooltip';

export interface StoreItemProps {
  hasStoreSelected?: boolean;
  storeName?: string;
  storeLocation?: string;
  isMobile?: boolean;
  assignDefaultStore?: boolean;
  isGuestUserOnCatcorp?: boolean;
  isMobileSearch?: boolean;
}

export const StoreClient = ({
  hasStoreSelected = false,
  storeName,
  storeLocation,
  isMobile = false,
  isGuestUserOnCatcorp,
  isMobileSearch
}: StoreItemProps) => {
  const t = useTranslations();
  const label = t('CAT_SELECT_STORE');
  const storeIconID = isMobile ? 'selectStoreMobile' : 'selectStore';
  const storeInfoDrawer = useStoreInfoDrawer();
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const drawerControl = hasStoreSelected
    ? storeInfoDrawer
    : dealerLocatorDrawer;
  const [isOpenFromNavItem, setIsOpenFromNavItem] = useState(false);

  const { handleToolTip, shouldDisplayTooltip } = useStoreLocatorTooltip(
    isGuestUserOnCatcorp,
    isMobile
  );

  const handleOpen = () => {
    drawerControl?.openDrawer();
    setIsOpenFromNavItem(true);
  };

  useLayoutEffect(() => {
    if (!drawerControl?.isDrawerOpen && isOpenFromNavItem) {
      setIsOpenFromNavItem(false);
      returnFocusToNavItem(`#${storeIconID}`);
    }
  }, [drawerControl?.isDrawerOpen, isOpenFromNavItem, storeIconID]);

  return (
    <HeaderStore
      id={storeIconID}
      label={hasStoreSelected ? storeName : label}
      subLabel={storeLocation}
      handleDrawerProps={drawerControl?.initiatorProps}
      action={handleOpen}
      isCurrent={isOpenFromNavItem}
      isMobile={isMobile}
      storeLocatorMessage={t('ALP_DEALER_SECTION_DESCRIPTION')}
      isTooltipActive={shouldDisplayTooltip}
      handleToolTip={handleToolTip}
      isMobileSearch={isMobileSearch}
    />
  );
};
